import * as React from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton
} from '@mui/material';
import { useEffect, useState } from 'react';
import { AppContext } from '../../context/AppContext';
import { BakeasyButtonCancel, BakeasyButtonConfirm } from '../../components/buttons/BakeasyButton';
import BakeasySimpleTable from '../../components/tables/BakeasySimpleTable';
import { HeadCell } from '../../components/tables/BakeasyTable';
import { useAppDispatch } from '../../redux_store/reduxStore';
import {
  cancelProduction,
  clearProductionReportState
} from '../../redux_store/slices/productionReportSlice';
import { Close } from '@mui/icons-material';
import { t } from 'i18next';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';

export const ProductionCancelOrder = (props: any) => {
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);

  const [quantity, setQuantity] = React.useState<any>([]);
  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [productionOrders, setProductionOrders] = useState<any[]>([]);

  useEffect(() => {
    if (props?.params?.data) {
      setData(props?.params?.data);
    }
  }, [props?.params?.data]);

  const tableHeaders: HeadCell[] = [
    { id: 'productionCancelOrderchecked', label: 'CHECK' },
    { id: 'status', label: 'STATUS' },
    { id: 'orderId', label: 'ORDER_ID' }
  ];

  function handleClose() {
    dispatch(clearProductionReportState());
    myContext.setDialog({ open: false });
    props?.onBack();
  }

  function setData(data: any) {
    if (data?.length > 0) {
      const productionOrders = data.map((item: any) => {
        return {
          id: item?._id,
          orderId: item?.orderId,
          checked: false,
          status: item?.status,
          disabled: item?.status?.toLowerCase() === 'cancelled'
        };
      });
      setProductionOrders(productionOrders);
    }
  }

  const handleRowCheck = (row: any, checked: boolean) => {
    if (checked) {
      setSelectedRows([...selectedRows, row]);
    } else {
      const filterRows = selectedRows.filter((tableRow: any) => tableRow._id !== row._id);
      setSelectedRows([...filterRows]);
    }
  };
  const handleConfirmClick = async () => {
    if (selectedRows.length === 0) {
      dispatch(showErrorSnackbar({ message: t('PLEASE_SELECT_ORDER_TO_CANCEL') }));
      return;
    }
    const payload = { ids: selectedRows.map((row: any) => row.id) };
    await dispatch(cancelProduction(payload));
    handleClose();
  };

  return (
    <>
      <DialogTitle
        sx={{ margin: 0, padding: 2 }}
        style={{ fontWeight: 600, fontSize: '1.2rem' }}
        minWidth={200}
      >
        <Grid container sx={{ flexDirection: 'row' }}>
          {t('SELECT_ORDERS_TO_CANCEL')}
        </Grid>
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={{ position: 'absolute', right: 8, top: 8, color: theme => theme.palette.grey[500] }}
      >
        <Close />
      </IconButton>
      <Divider />
      <DialogContent sx={{ margin: 0 }}>
        <Grid>
          {productionOrders?.length > 0 && (
            <BakeasySimpleTable
              headers={tableHeaders}
              tableData={productionOrders}
              handleSimpleCheckChanged={handleRowCheck}
            />
          )}
        </Grid>
      </DialogContent>
      <DialogActions sx={{ margin: 1 }}>
        <BakeasyButtonCancel onClick={handleClose} />
        <BakeasyButtonConfirm onClick={handleConfirmClick} />
      </DialogActions>
    </>
  );
};
